import React from 'react';
import { OptimizelyProvider as SDKProvider } from '@optimizely/react-sdk';
import { useRouter } from 'next/router';

import { Children } from 'types/common';
import {
  getOptimizelyUser,
  optimizelyClient,
} from 'services/optimizely/client';

const OptimizelyProvider = ({
  children,
}: {
  children: Children;
}): JSX.Element => {
  const router = useRouter();
  return (
    <>
      <SDKProvider
        optimizely={optimizelyClient}
        user={getOptimizelyUser({
          locale: router.locale,
        })}
      >
        {children}
      </SDKProvider>
    </>
  );
};

export default OptimizelyProvider;
